const getDate = newdate => {
    let year = newdate.getFullYear();
    let month = newdate.getMonth();

    if (month == 0) {
        month = 12;
        year = year - 1;
    }

    function getMonth(date) {
        var month = date;
        return month < 10 ? "0" + month : "" + month; // ('' + month) for string result
    }

    let finalMonth = getMonth(month);

    let date = year.toString() + finalMonth;

    return Number(date);
};

export default getDate;
